<script setup lang="ts">
import AIBetaBadge from '@/components/AIBetaBadge.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'
import { goalbookUrls } from '@/util/links'
import { FROM_HOME, HOME_EVENT_NAMES } from './event_names'

const analytics = getAnalyticsTracker()

function trackLaunchScoringTool() {
  analytics.sendEvent(HOME_EVENT_NAMES.CLICKED_LAUNCH_SCORING_TOOL, FROM_HOME)
}
</script>

<template>
  <section class="flex flex-wrap items-center justify-center gap-[28px] border-2 border-[#BDBDBD] p-[26px]" aria-label="Texas Intensity of Services">
    <div class="flex flex-col gap-2">
      <h3 class="m-0 flex items-center gap-3 text-[1.75rem] font-[600] leading-[1.1] text-[#266A95]">
        Texas Intensity of Services
        <span class="rounded-full bg-orange-50 px-[0.6rem] py-0.5 text-[0.75rem] font-[600] leading-[1.4] tracking-[0.05em] text-[#222222]">NEW</span>
      </h3>
      <p class="m-0 max-w-[520px] text-gray-900">Score your IEPs against the Texas service tiers funding model.</p>
    </div>
    <div class="relative">
      <span class="absolute left-1/2 top-0 flex -translate-x-1/2 -translate-y-1/2">
        <AIBetaBadge focusable />
      </span>
      <a
        :href="goalbookUrls.intensity"
        target="_blank"
        rel="noopener"
        aria-label="Launch scoring tool (Beta) (opens in new tab)"
        class="flex items-center justify-center whitespace-nowrap rounded-[8px] border border-[#23537B] px-6 py-4 text-lg font-[600] text-[#23537B] no-underline hover:bg-[#EEEEEE] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#23537B]"
        @click="trackLaunchScoringTool"
      >
        Launch scoring tool
        <span class="sr-only">(opens in new tab)</span>
      </a>
    </div>
  </section>
</template>
